import { useContext, useMemo } from "react";
import { ConfigLinksDetailsContext } from "../Context/cofingLinksDetailsContext";

// The file types and size citizens may upload, from the portal settings (server-driven flags).
export const useAttachmentRules = () => {
  const { configLinks } = useContext(ConfigLinksDetailsContext);

  return useMemo(() => {
    const allowImages = configLinks?.allowImages ?? true;
    const allowWordDocs = configLinks?.allowWordDocs ?? true;

    const baseMimes = new Set(["application/pdf", "image/jpeg"]);
    const baseMessages = ["PDF", "JPEG"];

    if (allowImages) {
      ["image/jpg", "image/png"].forEach((mime) => baseMimes.add(mime));
      baseMessages.push("JPG", "PNG");
    }

    if (allowWordDocs) {
      [
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ].forEach((mime) => baseMimes.add(mime));
      baseMessages.push("DOC", "DOCX");
    }

    const validFileTypes = Array.from(baseMimes);
    const fileSizeLimitMb = configLinks?.fileSizeLimitMb;

    // The error message for a file, or null when it can be uploaded.
    const fileError = (file) => {
      if (!validFileTypes.includes(file.type)) {
        return `الرجاء تحميل ملف صالح (${baseMessages})`;
      }
      if (fileSizeLimitMb && file.size > fileSizeLimitMb * 1024 * 1024) {
        return `حجم الملف لا يمكن ان يتجاوز ${fileSizeLimitMb} MB`;
      }
      return null;
    };

    return { validFileTypes, fileTypeMessages: baseMessages, fileError };
  }, [configLinks]);
};
